<template>
  <div class="work-review-list-component">
    <div class="review-block" id="review-block">
      <div class="block-title"
      >
        <div>
          评论
          <span class="desc"
                v-if="reviewsData.count > 0"
          >{{ reviewsData.count }}条</span>
        </div>
      </div>
      <div class="review-content">
        <review-list :reviews="reviewsData.list"
                     :next-start="reviewsData.start"
                     :target-id="workId"
                     target-type="work"
        />
      </div>
    </div>
  </div>
</template>

<script>
  import ReviewList from '@/components/CommentList/List';

  export default {
    name: 'WorkReviewListComponent',
    components: {
      ReviewList,
    },
    data() {
      return {
        reviewsData: null,
      };
    },
    props: {
      reviews: {
        type: Object,
        required: true,
        default() {
          return {};
        },
      },
      workId: {
        type: Number,
        required: true,
      },
    },
    watch: {
      reviews(val) {
        this.reviewsData = val;
      },
    },
    created() {
      this.reviewsData = this.reviews;
    },
  };
</script>

<style scoped lang="less">
  @import '~@/assets/styles/var.less';

  .review-block {
    background-color: @color-white;
    margin-bottom: @size-base;
  }

  .block-title {
    display: flex;
    align-items: center;
    justify-content: space-between;
    border-bottom: @border-base;
    line-height: 1;
    padding: @size-base;
    color: @color-text-base;
    font-weight: @font-weight-primary;
    .desc {
      font-weight: @font-weight-primary;
      font-size: @font-size-small;
      color: @color-text-lighter;
      margin-left: @size-extra-small / 2;
    }
  }

</style>
